"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrivalStatus = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledArrivalStatus = styled_components_1.default.p `
  background: ${(props) => props.status === 'early' ? config_1.colors.yellowLight : config_1.colors.blueLight};
  border-radius: 20px;
  color: ${config_1.colors.black};
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  height: 24px;
  padding: 4px;
  text-align: center;
  width: ${(props) => (props.status === 'early' ? '45px' : '65px')};
`;
